import { render } from "./VisitorStatusColumn.vue?vue&type=template&id=b70ff184&scoped=true"
import script from "./VisitorStatusColumn.vue?vue&type=script&lang=js"
export * from "./VisitorStatusColumn.vue?vue&type=script&lang=js"

import "./VisitorStatusColumn.vue?vue&type=style&index=0&id=b70ff184&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b70ff184"]])

export default __exports__